<script lang="ts">
import { defineComponent, provide, h, computed } from 'vue'
import { useAvatarGroup } from '../../components/avatar-group/hooks'
import { TUseAvatarGroup } from '../../components/avatar-group/types'

export default defineComponent({
  name: 'lp-avatar-group',
  props: {
    vertical: { type: Boolean },
    square: { type: Boolean },
    max: { type: Number, default: null },
    size: { type: String, default: '40px' },
  },
  setup(props, { slots }) {
    provide('square', props.square)
    provide('size', props.size)

    const { totalChildrenVNodes, label }: TUseAvatarGroup = useAvatarGroup(
      props,
      slots,
    )

    const classes = computed(() => ({
      'lp-avatar-group': true,
      'lp-avatar-group-v': props.vertical,
      'lp-avatar-group-h': !props.vertical,
    }))

    return () =>
      h(
        'div',
        {
          class: classes.value,
        },
        [
          totalChildrenVNodes.value,
          label.value.show
            ? h(
                'div',
                {
                  class: ['lp-avatar-group-max'],
                  style: { width: props.size, height: props.size },
                },
                [h('span', `+${label.value.count}`)],
              )
            : null,
        ],
      )
  },
})
</script>
